// SkeletonTable.tsx
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

export type SkeletonTableProps = {
  rows?: number;
  columns?: number;
  cellHeight?: number;
}

export const SkeletonTable: React.FC<SkeletonTableProps> = ({
  rows = 5,
  columns = 4,
  cellHeight = 20,
}) => {
  return (
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr>
          {Array.from({ length: columns }).map((_, i) => (
            <th key={i} style={{ padding: 8 }}>
              <Skeleton height={cellHeight} />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({ length: rows }).map((_, rowIndex) => (
          <tr key={rowIndex}>
            {Array.from({ length: columns }).map((_, colIndex) => (
              <td key={colIndex} style={{ padding: 8 }}>
                <Skeleton height={cellHeight} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
